import React, { Fragment } from 'react';

export const Hamburger = (
  <Fragment>
    <path d="M32,12 L8,12" stroke="currentColor" strokeWidth="2" />
    <path d="M32,20 L8,20" stroke="currentColor" strokeWidth="2" />
    <path d="M32,28 L8,28" stroke="currentColor" strokeWidth="2" />
  </Fragment>
);

export const Chevron = (
  <path
    fill="none"
    fillRule="evenodd"
    stroke="currentColor"
    d="M5 8l4.65 4.725L14.375 8"
  />
);

export const ChevronBack = (
  <path
    fillRule="evenodd"
    stroke="currentColor"
    d="M19.5,8 l-8,8 8,8 0.5,-0.5 -7.5,-7.5 7.5,-7.5 z"
  />
);

export const ChevronRight = (
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.29,17.29L5.29,17.29c0.39,0.39,1.02,0.39,1.41,0l6.59-6.59c0.39-0.39,0.39-1.02,0-1.41L6.71,2.71 c-0.39-0.39-1.02-0.39-1.41,0l0,0C4.9,3.1,4.9,3.73,5.29,4.12L11.17,10l-5.88,5.88C4.9,16.27,4.9,16.9,5.29,17.29z"
  />
);

export const ExpandMore = (
  <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
);

export const ExpandLess = (
  <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" />
);

export const Sort = (
  <path
    fill="currentColor"
    d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
  />
);

export const ArrowUp = (
  <path
    fill="currentColor"
    d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
  />
);

export const ArrowDown = (
  <path
    fill="currentColor"
    d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
  />
);

export const Play = <path d="M10,4 l0,24 l18,-12 z" />;

export const Calendar = (
  <Fragment>
    <path stroke="currentColor" fill="none" d="M2.5 3.5h15v15h-15z" />
    <path stroke="none" d="M2 3h16v3H2z" />
    <path stroke="currentColor" d="M4.5 2.5h1v3h-1zM14.5 2.5h1v3h-1z" />
    <path stroke="none" d="M11 12h4v4h-4z" />
  </Fragment>
);

export const Filter = (
  <>
    <path d="M0,0h24 M24,24H0" fill="none" />
    <path d="M4.25,5.61C6.57,8.59,10,13,10,13v5c0,1.1,0.9,2,2,2h0c1.1,0,2-0.9,2-2v-5c0,0,3.43-4.41,5.75-7.39 C20.26,4.95,19.79,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
    <path d="M0,0h24v24H0V0z" fill="none" />
  </>
);

export const People = (
  <>
    <circle cx="8.5" cy="7.5" fillRule="evenodd" r="2.5" />
    <path
      d="M10.99,9.95C11.16,9.98,11.33,10,11.5,10c1.38,0,2.5-1.12,2.5-2.5 C14,6.12,12.88,5,11.5,5c-0.17,0-0.34,0.02-0.51,0.05C11.61,5.68,12,6.55,12,7.5S11.61,9.32,10.99,9.95z"
      fillRule="evenodd"
    />
    <path
      d="M8.5,11C6.66,11,3,11.66,3,13.23v1.27C3,14.78,3.22,15,3.5,15h10 c0.28,0,0.5-0.22,0.5-0.5v-1.27C14,11.66,10.34,11,8.5,11z"
      fillRule="evenodd"
    />
    <path
      d="M13.73,11.23c0.75,0.48,1.27,1.12,1.27,2V15h1.5c0.28,0,0.5-0.22,0.5-0.5v-1.27 C17,12.18,15.36,11.54,13.73,11.23z"
      fillRule="evenodd"
    />
  </>
);

export const Schedule = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z" />
  </>
);

export const Cloud = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-8.64 6.25c-.39.39-1.02.39-1.41 0L7.2 14.2c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.18l4.48-4.48c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-5.18 5.18z" />
  </>
);

export const Star = (
  <>
    <path d="M0,0h24v24H0V0z" fill="none" />
    <path d="M0,0h24v24H0V0z" fill="none" />
    <path d="M12,17.27l4.15,2.51c0.76,0.46,1.69-0.22,1.49-1.08l-1.1-4.72l3.67-3.18c0.67-0.58,0.31-1.68-0.57-1.75l-4.83-0.41 l-1.89-4.46c-0.34-0.81-1.5-0.81-1.84,0L9.19,8.63L4.36,9.04c-0.88,0.07-1.24,1.17-0.57,1.75l3.67,3.18l-1.1,4.72 c-0.2,0.86,0.73,1.54,1.49,1.08L12,17.27z" />
  </>
);

export const Done = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
  </>
);

export const Flag = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M14.4 6l-.24-1.2c-.09-.46-.5-.8-.98-.8H6c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5.6l.24 1.2c.09.47.5.8.98.8H19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-4.6z" />
  </>
);

export const Label = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84l3.96-5.58c.25-.35.25-.81 0-1.16l-3.96-5.58z" />
  </>
);

export const Brightness = (
  <>
    <rect
      id="Rectangle_1589"
      data-name="Rectangle 1589"
      width="24"
      height="24"
      fill="none"
    />
    <circle
      id="Ellipse_35"
      data-name="Ellipse 35"
      cx="10"
      cy="10"
      r="10"
      transform="translate(2 2)"
      fill="currentColor"
    />
    <text
      id="S"
      transform="translate(8 17)"
      fill="#fff"
      fontSize="14"
      fontFamily="OpenSans, Open Sans"
    >
      <tspan x="0" y="0">
        S
      </tspan>
    </text>
  </>
);

export const AddCircle = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z" />
  </>
);

export const RemoveCircle = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z" />
  </>
);

export const AddCircleUnfilled = (
  <>
    <path d="M12.2415 0C5.58521 0 0.241455 5.39062 0.241455 12C0.241455 18.6562 5.58521 24 12.2415 24C18.8508 24 24.2415 18.6562 24.2415 12C24.2415 5.39062 18.8508 0 12.2415 0ZM12.2415 22.5C6.42896 22.5 1.74146 17.8125 1.74146 12C1.74146 6.23438 6.42896 1.5 12.2415 1.5C18.0071 1.5 22.7415 6.23438 22.7415 12C22.7415 17.8125 18.0071 22.5 12.2415 22.5ZM16.7415 11.25H12.9915V7.5C12.9915 7.125 12.6165 6.75 12.2415 6.75C11.8196 6.75 11.4915 7.125 11.4915 7.5V11.25H7.74146C7.31958 11.25 6.99146 11.625 6.99146 12C6.99146 12.4219 7.31958 12.75 7.74146 12.75H11.4915V16.5C11.4915 16.9219 11.8196 17.25 12.2415 17.25C12.6165 17.25 12.9915 16.9219 12.9915 16.5V12.75H16.7415C17.1165 12.75 17.4915 12.4219 17.4915 12C17.4915 11.625 17.1165 11.25 16.7415 11.25Z" />
  </>
);

export const RemoveCircleUnfilled = (
  <>
    <path d="M16.7415 11.25H7.74146C7.31958 11.25 6.99146 11.625 6.99146 12C6.99146 12.4219 7.31958 12.75 7.74146 12.75H16.7415C17.1165 12.75 17.4915 12.4219 17.4915 12C17.4915 11.625 17.1165 11.25 16.7415 11.25ZM12.2415 0C5.58521 0 0.241455 5.39062 0.241455 12C0.241455 18.6562 5.58521 24 12.2415 24C18.8508 24 24.2415 18.6562 24.2415 12C24.2415 5.39062 18.8508 0 12.2415 0ZM12.2415 22.5C6.42896 22.5 1.74146 17.8125 1.74146 12C1.74146 6.23438 6.42896 1.5 12.2415 1.5C18.0071 1.5 22.7415 6.23438 22.7415 12C22.7415 17.8125 18.0071 22.5 12.2415 22.5Z" />
  </>
);

export const Close = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
  </>
);

export const CheckCircle = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z" />
  </>
);

export const Email = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z" />
  </>
);

export const Phone = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z" />
  </>
);

export const Info = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z" />
  </>
);

export const InfoEmpty = (
  <path d="M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM8 15C4.14062 15 1 11.8594 1 8C1 4.14062 4.14062 1 8 1C11.8594 1 15 4.14062 15 8C15 11.8594 11.8594 15 8 15ZM8 5.75C8.41406 5.75 8.75 5.41438 8.75 5C8.75 4.58594 8.41406 4.25 8 4.25C7.58594 4.25 7.25 4.58437 7.25 5C7.25 5.41563 7.58437 5.75 8 5.75ZM9.5 11H8.5V7.5C8.5 7.225 8.275 7 8 7H7C6.725 7 6.5 7.225 6.5 7.5C6.5 7.775 6.725 8 7 8H7.5V11H6.5C6.225 11 6 11.225 6 11.5C6 11.775 6.225 12 6.5 12H9.5C9.77613 12 10 11.7761 10 11.5C10 11.225 9.775 11 9.5 11Z" />
);

export const VerticalEllipsis = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </>
);

export const Error = (
  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z" />
);

export const Warning = (
  <path d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z" />
);

export const Drag = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </>
);
export const Trash = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z" />
  </>
);
export const History = (
  <>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M13.26 3C8.17 2.86 4 6.95 4 12H2.21c-.45 0-.67.54-.35.85l2.79 2.8c.2.2.51.2.71 0l2.79-2.8c.31-.31.09-.85-.36-.85H6c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.61 0-3.1-.55-4.28-1.48-.4-.31-.96-.28-1.32.08-.42.42-.39 1.13.08 1.49C9 20.29 10.91 21 13 21c5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74zm-.51 5c-.41 0-.75.34-.75.75v3.68c0 .35.19.68.49.86l3.12 1.85c.36.21.82.09 1.03-.26.21-.36.09-.82-.26-1.03l-2.88-1.71v-3.4c0-.4-.34-.74-.75-.74z" />
  </>
);
export const B2CLoading = (
  <path d="M12.8491 17.774H12.8465C11.707 17.7741 10.6027 17.379 9.72182 16.6561C8.84095 15.9333 8.23798 14.9273 8.01565 13.8097C7.79331 12.6921 7.96537 11.532 8.5025 10.527C9.03963 9.52207 9.90861 8.73444 10.9614 8.29835C12.0141 7.86225 13.1855 7.80468 14.276 8.13543C15.3664 8.46619 16.3084 9.16481 16.9415 10.1123C17.5746 11.0597 17.8596 12.1974 17.7479 13.3314C17.6363 14.4654 17.1349 15.5256 16.3291 16.3314C15.8876 16.7883 15.3585 17.1516 14.7734 17.3995C14.1883 17.6474 13.5592 17.7748 12.9238 17.774H12.8465H12.8491ZM4.92912 36.9261H4.92646C3.78695 36.9261 2.68269 36.531 1.80182 35.8081C0.920955 35.0853 0.317984 34.0793 0.0956485 32.9617C-0.126687 31.8441 0.0453699 30.684 0.582503 29.679C1.11964 28.6741 1.98861 27.8864 3.04136 27.4504C4.09412 27.0143 5.26551 26.9567 6.35596 27.2874C7.4464 27.6182 8.38843 28.3168 9.02152 29.2643C9.65462 30.2117 9.93961 31.3494 9.82794 32.4834C9.71628 33.6174 9.21486 34.6776 8.40912 35.4834C7.96727 35.9407 7.43772 36.3041 6.85214 36.552C6.26657 36.7999 5.637 36.9271 5.00112 36.9261H4.91846H4.92379H4.92912ZM32.0011 9.84872H31.9985C30.859 9.84875 29.7547 9.45367 28.8738 8.7308C27.993 8.00793 27.39 7.002 27.1676 5.88439C26.9453 4.76679 27.1174 3.60667 27.6545 2.60171C28.1916 1.59674 29.0606 0.809107 30.1134 0.373013C31.1661 -0.0630822 32.3375 -0.120657 33.428 0.210098C34.5184 0.540853 35.4604 1.23947 36.0935 2.18692C36.7266 3.13437 37.0116 4.27203 36.8999 5.40605C36.7883 6.54006 36.2869 7.60028 35.4811 8.40605C35.0396 8.86301 34.5105 9.22628 33.9254 9.47416C33.3403 9.72203 32.7112 9.84942 32.0758 9.84872H31.9985H32.0011ZM12.8491 56.0807H12.8465C11.707 56.0808 10.6027 55.6857 9.72182 54.9628C8.84095 54.2399 8.23798 53.234 8.01565 52.1164C7.79331 50.9988 7.96537 49.8387 8.5025 48.8337C9.03963 47.8287 9.90861 47.0411 10.9614 46.605C12.0141 46.1689 13.1855 46.1113 14.276 46.4421C15.3664 46.7729 16.3084 47.4715 16.9415 48.4189C17.5746 49.3664 17.8596 50.504 17.7479 51.6381C17.6363 52.7721 17.1349 53.8323 16.3291 54.6381C15.8883 55.0952 15.3597 55.4586 14.775 55.7065C14.1903 55.9544 13.5615 56.0817 12.9265 56.0807H12.8438H12.8491ZM51.1531 19.0034C50.3343 19.0204 49.5203 18.8739 48.7588 18.5723C47.9973 18.2707 47.3037 17.8202 46.7185 17.2471C46.1334 16.674 45.6685 15.9899 45.3512 15.2349C45.0338 14.4799 44.8703 13.6691 44.8703 12.85C44.8703 12.031 45.0338 11.2202 45.3512 10.4652C45.6685 9.71016 46.1334 9.02606 46.7185 8.45298C47.3037 7.87991 47.9973 7.42938 48.7588 7.1278C49.5203 6.82623 50.3343 6.67967 51.1531 6.69672C52.7629 6.73023 54.2955 7.39325 55.4221 8.54357C56.5487 9.6939 57.1797 11.2399 57.1797 12.85C57.1797 14.4602 56.5487 16.0062 55.4221 17.1565C54.2955 18.3069 52.7629 18.9699 51.1531 19.0034ZM32.0011 64.0034H31.9985C30.859 64.0034 29.7547 63.6083 28.8738 62.8855C27.993 62.1626 27.39 61.1567 27.1676 60.0391C26.9453 58.9215 27.1174 57.7613 27.6545 56.7564C28.1916 55.7514 29.0606 54.9638 30.1134 54.5277C31.1661 54.0916 32.3375 54.034 33.428 54.3648C34.5184 54.6955 35.4604 55.3941 36.0935 56.3416C36.7266 57.289 37.0116 58.4267 36.8999 59.5607C36.7883 60.6947 36.2869 61.755 35.4811 62.5607C35.0396 63.0177 34.5105 63.381 33.9254 63.6288C33.3403 63.8767 32.7112 64.0041 32.0758 64.0034H31.9985H32.0011ZM59.0785 39.3874H58.9505C56.9505 39.3874 55.1425 38.5634 53.8491 37.2354L53.8465 37.2327C52.5158 35.8914 51.6918 34.0434 51.6918 32.0034C51.6918 29.9634 52.5131 28.1154 53.8465 26.7714C54.5094 26.0885 55.3029 25.5459 56.1797 25.1758C57.0565 24.8056 57.9987 24.6155 58.9505 24.6167H59.0838H59.0758H59.2038C61.2038 24.6167 63.0091 25.4407 64.3051 26.7687L64.3078 26.7714C65.6385 28.1127 66.4625 29.9607 66.4625 32.0007C66.4625 34.0407 65.6411 35.8887 64.3078 37.2327C63.6446 37.9162 62.8508 38.4595 61.9736 38.8301C61.0963 39.2007 60.1535 39.3911 59.2011 39.3901H59.0704H59.0758L59.0785 39.3874ZM51.1558 59.7687H51.0225C49.9089 59.7698 48.8067 59.5457 47.782 59.1099C46.7573 58.6741 45.8314 58.0356 45.0598 57.2327L45.0571 57.2301C43.4998 55.6727 42.5371 53.5207 42.5371 51.1421C42.5371 48.7634 43.4998 46.6141 45.0571 45.0541C45.8303 44.2559 46.7562 43.6214 47.7796 43.1885C48.8031 42.7555 49.9032 42.533 51.0145 42.5341H51.1585H51.1505H51.2625C53.6011 42.5341 55.7158 43.4994 57.2278 45.0514L57.2305 45.0541C58.7985 46.6061 59.7691 48.7607 59.7691 51.1421C59.7691 53.5234 58.7985 55.6754 57.2305 57.2274C56.4576 58.0319 55.53 58.6717 54.5035 59.1085C53.477 59.5452 52.3727 59.7698 51.2571 59.7687H51.1505H51.1558Z" />
);
export const B2CPerson = (
  <path
    d="M12.2427 8.75625L10.3143 5.28438C9.90209 4.49375 9.06459 4 8.15522 4H7.51147C6.60209 4 5.76522 4.49375 5.32459 5.2875L3.39616 8.75625C3.26237 8.99747 3.34928 9.30156 3.59047 9.43594C3.82972 9.56875 4.13547 9.48428 4.27109 9.24159L6.19953 5.76972C6.46459 5.29688 6.96459 5 7.51147 5H8.15803C8.70303 5 9.20491 5.29541 9.46834 5.77156L11.3968 9.24344C11.4865 9.40625 11.6583 9.5 11.8333 9.5C11.9163 9.5 11.9987 9.47998 12.0758 9.437C12.3177 9.30313 12.4052 8.97188 12.2427 8.75625ZM7.83334 3.5C8.79803 3.5 9.55522 2.715 9.55522 1.75C9.55522 0.785 8.79897 0 7.83334 0C6.86772 0 6.11147 0.785 6.11147 1.75C6.11147 2.715 6.86772 3.5 7.83334 3.5ZM7.83334 1C8.24647 1 8.55522 1.33656 8.55522 1.75C8.55522 2.16344 8.24584 2.5 7.83334 2.5C7.42084 2.5 7.08334 2.16344 7.08334 1.75C7.08334 1.33656 7.42084 1 7.83334 1ZM9.30522 7.5C9.02888 7.5 8.83334 7.72363 8.83334 8V10.5H6.83334V8C6.83334 7.72363 6.60972 7.5 6.36147 7.5C6.11322 7.5 5.83334 7.725 5.83334 8V15.5C5.83334 15.7764 6.05697 16 6.30522 16C6.55347 16 6.77709 15.7764 6.77709 15.5V11.5H8.74897V15.5C8.74897 15.7764 8.97259 16 9.22084 16C9.46909 16 9.69272 15.7764 9.69272 15.5V8C9.80522 7.725 9.60834 7.5 9.30522 7.5Z"
    fill="white"
  />
);
export const B2CChild = (
  <path
    d="M8.00005 5.83332C9.24224 5.83332 10.2501 4.82551 10.2501 3.58332C10.2501 2.34114 9.2438 1.33331 8.00005 1.33331C6.7563 1.33331 5.72193 2.34114 5.72193 3.58332C5.72193 4.82551 6.75943 5.83332 8.00005 5.83332ZM8.00005 2.33332C8.68943 2.33332 9.25005 2.89395 9.25005 3.58332C9.25005 4.2727 8.69068 4.83332 8.00005 4.83332C7.31099 4.83332 6.75005 4.2727 6.75005 3.58332C6.75005 2.89395 7.30943 2.33332 8.00005 2.33332ZM13.7594 4.90832C13.5245 4.76623 13.2169 4.84045 13.0735 5.07532C13.0157 5.1677 11.6438 7.33332 8.00005 7.33332C4.36256 7.33332 2.98881 5.17395 2.92787 5.07395C2.78568 4.83957 2.47943 4.76145 2.24287 4.9052C2.00631 5.04895 1.92912 5.3552 2.07131 5.58957C2.1235 5.64895 3.11006 7.25832 5.50006 7.98019V13.5C5.50006 13.7764 5.72368 14 5.97193 14C6.27506 14 6.50005 13.775 6.50005 13.5V11.5H9.50005V13.5C9.50005 13.7764 9.72368 14 10.0001 14C10.2764 14 10.5001 13.775 10.5001 13.5V7.98019C12.89 7.26019 13.8782 5.67832 13.9282 5.59207C14.0719 5.3552 13.9938 5.04895 13.7594 4.90832ZM9.50005 10.5H6.50005V8.21457C6.95943 8.28957 7.4563 8.33332 8.00005 8.33332C8.5438 8.33332 9.04099 8.28907 9.50005 8.21351V10.5Z"
    fill="white"
  />
);

export const B2CCalendar = (
  <path d="M10.25 11.8672L12.3203 12.1797C12.6719 12.2188 12.7891 12.6484 12.5547 12.8828L11.0703 14.3281L11.4219 16.3594C11.4609 16.7109 11.1094 16.9453 10.8359 16.7891L9 15.8125L7.125 16.7891C6.85156 16.9453 6.5 16.7109 6.53906 16.3594L6.89062 14.3281L5.40625 12.8828C5.17188 12.6484 5.28906 12.2188 5.64062 12.1797L7.71094 11.8672L8.60938 9.99219C8.76562 9.71875 9.19531 9.71875 9.35156 9.99219L10.25 11.8672ZM5.25 0.5C5.75781 0.5 6.1875 0.929688 6.1875 1.4375V3H11.8125V1.4375C11.8125 0.929688 12.2031 0.5 12.75 0.5C13.2578 0.5 13.6875 0.929688 13.6875 1.4375V3H15.25C16.6172 3 17.75 4.13281 17.75 5.5V18C17.75 19.4062 16.6172 20.5 15.25 20.5H2.75C1.34375 20.5 0.25 19.4062 0.25 18V5.5C0.25 4.13281 1.34375 3 2.75 3H4.3125V1.4375C4.3125 0.929688 4.70312 0.5 5.25 0.5ZM15.875 8H2.125V18C2.125 18.3516 2.39844 18.625 2.75 18.625H15.25C15.5625 18.625 15.875 18.3516 15.875 18V8Z" />
);

export const B2CCard = (
  <path d="M43.4827 8.66653H8.81601C8.24756 8.66508 7.68446 8.77634 7.15928 8.99386C6.63409 9.21139 6.15724 9.53087 5.75629 9.93383C5.35535 10.3368 5.03826 10.8152 4.82337 11.3415C4.60848 11.8678 4.50005 12.4314 4.50434 12.9999L4.48268 38.9999C4.48067 39.5695 4.59139 40.1339 4.80845 40.6605C5.02551 41.1872 5.34463 41.6657 5.74741 42.0685C6.1502 42.4713 6.6287 42.7904 7.15535 43.0074C7.682 43.2245 8.24639 43.3352 8.81601 43.3332H43.4827C44.0523 43.3352 44.6167 43.2245 45.1433 43.0074C45.67 42.7904 46.1485 42.4713 46.5513 42.0685C46.9541 41.6657 47.2732 41.1872 47.4902 40.6605C47.7073 40.1339 47.818 39.5695 47.816 38.9999V12.9999C47.818 12.4302 47.7073 11.8658 47.4902 11.3392C47.2732 10.8126 46.9541 10.3341 46.5513 9.93127C46.1485 9.52848 45.67 9.20936 45.1433 8.9923C44.6167 8.77524 44.0523 8.66453 43.4827 8.66653ZM41.316 38.9999H10.9827C10.408 38.9999 9.85694 38.7716 9.45061 38.3653C9.04428 37.9589 8.81601 37.4078 8.81601 36.8332V25.9999H43.4827V36.8332C43.4827 37.4078 43.2544 37.9589 42.8481 38.3653C42.4417 38.7716 41.8906 38.9999 41.316 38.9999ZM43.4827 17.3332H8.81601V12.9999H43.4827V17.3332Z" />
);

export const B2CDollar = (
  <path d="M26.8515 8.68604C23.2505 8.68604 19.7304 9.75306 16.7363 11.7522C13.7421 13.7513 11.4085 16.5927 10.0305 19.9171C8.65242 23.2415 8.29186 26.8996 8.99438 30.4287C9.6969 33.9579 11.4309 37.1996 13.9772 39.744C16.5235 42.2884 19.7677 44.0211 23.2995 44.7231C26.8313 45.4251 30.4921 45.0648 33.819 43.6878C37.1459 42.3108 39.9894 39.9789 41.99 36.9871C43.9906 33.9952 45.0584 30.4777 45.0584 26.8794C45.0567 22.0547 43.1379 17.4282 39.7238 14.0166C36.3098 10.6051 31.6798 8.68776 26.8515 8.68604ZM28.4536 37.3589V38.0097C28.453 38.4341 28.284 38.841 27.9837 39.1411C27.6834 39.4412 27.2762 39.61 26.8515 39.6106C26.4268 39.61 26.0196 39.4412 25.7193 39.1411C25.419 38.841 25.25 38.4341 25.2494 38.0097V37.2461C24.2022 37.0085 23.2203 36.543 22.3737 35.8827C21.5272 35.2224 20.8369 34.3836 20.352 33.4261C20.2565 33.2327 20.2019 33.0217 20.1917 32.8063C20.1816 32.5909 20.2159 32.3756 20.2927 32.1741C20.3696 31.9726 20.4871 31.789 20.6381 31.6349C20.7891 31.4808 20.9703 31.3595 21.1704 31.2786L21.2984 31.2243C21.6557 31.0754 22.0558 31.0657 22.4198 31.197C22.7839 31.3283 23.0855 31.5911 23.2652 31.9337C23.603 32.6743 24.146 33.3026 24.8301 33.7444C25.5141 34.1861 26.3106 34.4227 27.125 34.4261C28.8183 34.4261 30.7308 33.5584 30.7308 31.4977C30.7308 29.7514 29.4565 28.8404 26.5801 27.81C24.5764 27.1006 20.48 25.9358 20.48 21.7882C20.5157 20.4727 21.0139 19.2118 21.8873 18.2268C22.7606 17.2419 23.9533 16.5958 25.2559 16.402V15.7512C25.2565 15.3268 25.4255 14.92 25.7258 14.6199C26.0261 14.3198 26.4333 14.1509 26.858 14.1503C27.2827 14.1509 27.6899 14.3198 27.9902 14.6199C28.2905 14.92 28.4595 15.3268 28.4601 15.7512V16.4237C30.0268 16.6769 31.4356 17.5238 32.3937 18.7881C32.5366 18.9773 32.6341 19.1967 32.6787 19.4295C32.7233 19.6622 32.7138 19.9021 32.6508 20.1307C32.5879 20.3592 32.4732 20.5701 32.3157 20.7473C32.1582 20.9245 31.9621 21.0632 31.7424 21.1526C31.4198 21.2819 31.0637 21.302 30.7285 21.21C30.3933 21.1179 30.0975 20.9187 29.8863 20.6428C29.5516 20.1899 29.1113 19.8255 28.6036 19.5813C28.0959 19.337 27.5361 19.2204 26.9731 19.2415C25.6988 19.2415 23.6777 19.914 23.6777 21.7708C23.6777 23.5062 25.2429 24.157 28.484 25.2286C32.8539 26.7471 33.9654 28.9575 33.9654 31.5063C33.9272 32.9883 33.344 34.4042 32.3273 35.4838C31.3106 36.5634 29.9316 37.2309 28.4536 37.3589Z" />
);
